export default "__VITE_ASSET__9qHyXb5Y__"